import { render, staticRenderFns } from "./featurePage.vue?vue&type=template&id=9c22663a&scoped=true&"
import script from "./featurePage.vue?vue&type=script&lang=js&"
export * from "./featurePage.vue?vue&type=script&lang=js&"
import style0 from "./featurePage.vue?vue&type=style&index=0&id=9c22663a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c22663a",
  null
  
)

export default component.exports